// removed by extract-text-webpack-plugin
module.exports = {"modalContent":"_1ut-7Y8-A_lIDZDTTwYQqh","modalTitle":"_1ucYTw-HmBFTWTjdZpVBBu","modalSubtitle":"_28S2ufv_tQsk8PU0vbWqb2","modalActions":"_1GHPsCdV3Uw0vh8FHfADQS","closeButton":"_3R-gT5PoBdb2uWNh_VFZ6g","greyButton":"_7oasjlfHS-PJfiWpKiJNp","enabled":"_3CvCMra9-ktBcaGx_NLoDQ","taskItemsList":"_1UebrMLQfc2HIHg9urTT8p","taskItem":"_2weYrNpw0Oddi4pBZpTApz","taskField":"_2IFbtigIhj8VjQX5M7vpuY","dateInput":"xEtKZcKItG_ION8MO2Kum","staffItemsList":"_2oZgrslvi2gK7yOucshSfN","archiveSubtitleLast":"w1MT3gX72p4kvoM56_knX","message":"_1TyCwK7-qbKkgWUOW5K_21","error":"_22QJ57UpZeF4tbzXnIilt_"};


//////////////////
// WEBPACK FOOTER
// ./components/taskCreator/taskCreatorForm.scss
// module id = 1627
// module chunks = 0